module.exports = __webpack_public_path__ + "img/ES2045.175f299c.png";